// Ch78 · the Website form's SMS checkbox, read the same way everywhere.
//
// `leads.sms_opted_in` is written by the Website's submit-lead function
// (live since 2026-05-18) and was rendered NOWHERE in this app — a lead who
// ticked "yes, text me" looked identical to one who did not, and Grant's first
// question about a converted lead was exactly that. Three states, on purpose:
//
//   yes      they ticked the box — the cheapest next action on the board
//   no       the box was there and left unticked — NOT a refusal, merely
//            "not asked"; never render it as an opt-out
//   unknown  the row does not carry the field (older payloads) — say nothing
//
// The consent LEDGER (sms_consent, keyed by phone) is the send gate's truth;
// this is the form's answer, bridged into that ledger by the backend. The two
// agree once the bridge has run; this helper only reads the form's tick.

export type LeadTextsOptIn = "yes" | "no" | "unknown";

export function leadTextsOptIn(
  lead: { sms_opted_in?: boolean | null } | null | undefined
): LeadTextsOptIn {
  if (!lead || lead.sms_opted_in === undefined) return "unknown";
  return lead.sms_opted_in === true ? "yes" : "no";
}

/** Chip copy — short enough to sit first in a chip row on a phone. */
export const LEAD_TEXTS_CHIP_LABEL = "Texts OK";

/** One-line copy for a detail view. Empty when nothing is known. */
export function leadTextsOptInLabel(state: LeadTextsOptIn): string {
  if (state === "yes") return "Asked to be texted (form)";
  if (state === "no") return "Did not tick SMS on the form";
  return "";
}


// ---------------------------------------------------------------- email tick
//
// `leads.email_list_opt_in` is the form's OTHER consent box and was rendered
// nowhere, so the page could tell you who you may text and stayed silent about
// who you may email. Identical three states, for identical reasons: "no" means
// the box was there and left unticked — NOT a refusal — and a row that does not
// carry the field says nothing at all rather than guessing.

export function leadEmailOptIn(
  lead: { email_list_opt_in?: boolean | null } | null | undefined
): LeadTextsOptIn {
  if (!lead || lead.email_list_opt_in === undefined) return "unknown";
  return lead.email_list_opt_in === true ? "yes" : "no";
}

/** One-line copy for a detail view. Empty when nothing is known. */
export function leadEmailOptInLabel(state: LeadTextsOptIn): string {
  if (state === "yes") return "Asked to be emailed (form)";
  if (state === "no") return "Did not tick the email list on the form";
  return "";
}
